import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-modal';
import EditTabSettings from '../../../inputs/EditTabSettings';

const ColorPickerPopup = (props) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const dispatch = useDispatch();

    const openModal = () => {
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const defaultStyle = {
        background: props.bg_color,
        backgroundColor: props.bg_color,
        color: props.font_color,
    };

    return (
        <span>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="PickColor"
                className="d-flex justify-content-center"
                ariaHideApp={false}
                overlayClassName="overlay"
            >
                <div className="card col-md-6 md-auto space-top-2 pad-left-0 pad-right-0">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Select Color</h4>
                            <button type="button" className="close" onClick={closeModal}>&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="card-block bg-white">
                                <div className="p-2">
                                    <EditTabSettings 
                                        {...props} 
                                        type={props.type} 
                                        name={props.name} 
                                        value={props.value} 
                                        dataid={props.dataid} 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <button className="btn btn-sm btn-clear" style={defaultStyle} onClick={openModal}>
                <i className="fal fa-edit" />
                {' '}
            </button>
        </span>
    );
};

export default ColorPickerPopup;